import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { getConsolidadoPeriodo } from "../../../services/services";
import formatDateType from "../../../utils/formatDateType";
import LoadingChart from "./loadingChart";

export default function Rendimiento(props) {
  const SECUENCIA = 7;

  // Objeto por default de los states
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  const [totalizadorTurno, setToralizadorTurno] = useState(defaultObject);
  const [planSemanal, setPlanSemanal] = useState(defaultObject);
  const [planMensual, setPlanMensual] = useState(defaultObject);
  const [pOAnio, setPOAnio] = useState(defaultObject);

  //Totalizador semana
  const [valorSemanaTotalizador, setValorSemanaTotalizador] =
    useState(defaultObject);
  //Totalizador mes
  const [valorMesTotalizador, setValorMesTotalizador] = useState(defaultObject);
  //Totalizador Año
  const [valorAnioTotalizador, setValorAnioTotalizador] =
    useState(defaultObject);

  const [isLoading, setIsLoading] = useState(true);

  // Efecto que se ejecturara cada vez que cambien las props
  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const { data } = await getConsolidadoPeriodo({
        secuencia: SECUENCIA,
        periodo: props.periodo,
      });
      populateTotalizadorTurno(data);
      populateTotalizadorSemana(data);
      populateTotalizadorMes(data);
      populateTotalizadorAnio(data);

      populatePlanSemanal(data);
      populatePlanMensual(data);
      populatePO(data);
      setIsLoading(false);
    }

    fetchData();
  }, [props]);

  function populatePO(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "P0 (año): Rendimiento"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorAgno);
      arrFechas.push(element.fecha);
    });

    setPOAnio({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePlanMensual(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Plan mensual: Rendimiento"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorMes);
      arrFechas.push(element.fecha);
    });

    setPlanMensual({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePlanSemanal(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Plan semanal: Rendimiento"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorSemana);
      arrFechas.push(element.fecha);
    });

    setPlanSemanal({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorTurno(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Rendimiento: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(element.fecha);
    });

    setToralizadorTurno({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorSemana(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Rendimiento: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorSemana);
      arrFechas.push(element.fecha);
    });

    setValorSemanaTotalizador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorMes(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Rendimiento: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorMes);
      arrFechas.push(element.fecha);
    });

    setValorMesTotalizador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorAnio(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Rendimiento: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorAgno);
      arrFechas.push(element.fecha);
    });

    setValorAnioTotalizador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      {isLoading ? (
        <LoadingChart />
      ) : (
        <Card>
          <Card.Content>
            <Chart title="Rendimiento" zoom="x">
              {props.periodo !== "A" ? (
                <Chart.Column
                  name="Rendimiento"
                  data={totalizadorTurno.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {props.periodo === "S" ? (
                <Chart.Column
                  name="Rendimiento: Semana"
                  data={valorSemanaTotalizador.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {props.periodo === "M" || props.periodo === "A" ? (
                <Chart.Column
                  name="Rendimiento: Mes"
                  data={valorMesTotalizador.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {props.periodo === "A" ? (
                <Chart.Column
                  name="Rendimiento: Año"
                  data={valorAnioTotalizador.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {props.periodo === "S" ? (
                <Chart.Line
                  name="Plan semanal: Rendimiento"
                  data={planSemanal.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {/* Plan mensual solo debe mostrar cuando la props sea M */}
              {props.periodo === "M" ? (
                <Chart.Line
                  name="Plan mensual: Rendimiento"
                  data={planMensual.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {/* Plan mensual solo debe mostrar cuando la props sea A */}
              {props.periodo === "A" ? (
                <Chart.Line
                  name="P0 (año): Rendimiento"
                  data={pOAnio.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              <Chart.XAxis
                categories={
                  props.periodo === "S"
                    ? formatDateType(planSemanal.fecha, "S")
                    : props.periodo === "M"
                    ? formatDateType(planSemanal.fecha, "M")
                    : formatDateType(planSemanal.fecha, "A")
                }
              />

              <Chart.YAxis
                labelSuffix=" t/h bs"
                title="Flujo Másico, t/h bs"
                lineWidth={2}
                lineColor="white"
                max={120}
              />

              <Chart.Tooltip valueSuffix=" t/h bs" />
            </Chart>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
